import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import { Filter } from '../../../../../static/icons/filter';
// import { FilterOptions } from '../../../../constants/filterOptions';
import { FilterItem } from '../../../molecules/category/filterItem/FilterItem';

export const Filters = ({
  filters,
  selectedFilters,
  onFilterChange,
  handleClearFilters,
  category,
  sortFunction,
  labelFunction,
  t,
}) => (
  <Stack className="bg-white shadow-md min-h-80 w-full rounded-2xl gap-0">
    <Row className="py-2 justify-between items-center border-b border-customGray-200 px-4">
      <Row className="items-center">
        <Filter />
        <Typography fontVariant="h8">{t('catFilter.quickGuide')}</Typography>
      </Row>
      <button
        type="button"
        onClick={handleClearFilters}
        className="text-clamp-sm pl-4 py-2 !text-primary-500 font-normal"
      >
        {t('catFilter.clear')}
      </button>
    </Row>
    <Stack className="flex-1 px-4">
      {filters.map((option) => (
        <FilterItem
          key={`filter-${option.id}`}
          title={option.filterNameNice}
          category={category}
          description={option.description || ''}
          options={option.filterFields}
          optionsName={option.filterFieldsNice}
          optionsLocaleString={option?.filterFieldsLocaleString}
          sort={option?.sort}
          isOpenDefault={option.isOpenDefault}
          selection={option.selection}
          selectedFilters={selectedFilters[option.id]}
          onFilterChange={(selectedOption, type) =>
            onFilterChange(option.id, selectedOption, type)
          }
          labelFunction={labelFunction}
          sortFunction={sortFunction}
          t={t}
        />
      ))}
    </Stack>
  </Stack>
);
